import { useTranslation } from 'react-i18next';

export default function OverseasServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Minpaku License Application',
      description: 'Complete support for Residential Lodging Business Act compliance, including all required documentation and government submissions.',
      features: ['Document preparation', 'Government submission', 'Follow-up support', 'Compliance check']
    },
    {
      icon: 'ri-hotel-line',
      title: 'Hotel Business License',
      description: 'Full assistance with hotel business license application when required for your property type and business model.',
      features: ['Eligibility assessment', 'Application process', 'Inspection support', 'License acquisition']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Full Operations Management',
      description: 'Complete day-to-day management including guest communication, pricing optimization, and review management.',
      features: ['24/7 guest support', 'Dynamic pricing', 'Review management', 'Booking optimization']
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Cleaning & Property Care',
      description: 'Professional cleaning and on-site management to maintain your property in perfect condition for every guest.',
      features: ['Professional cleaning', 'Linen service', 'Maintenance checks', 'Emergency response']
    },
    {
      icon: 'ri-calculator-line',
      title: 'Tax Filing Support',
      description: 'Specialized tax support for non-resident owners, ensuring full compliance with Japanese tax regulations.',
      features: ['Non-resident tax filing', 'Income reporting', 'Deduction optimization', 'Tax authority liaison']
    },
    {
      icon: 'ri-file-chart-line',
      title: 'English Monthly Reports',
      description: 'Transparent, detailed monthly reports in English covering all aspects of your property performance and financials.',
      features: ['Revenue breakdown', 'Occupancy analytics', 'Expense tracking', 'Performance insights']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-gray-900 text-white text-sm font-semibold rounded-full mb-4">
            COMPREHENSIVE SERVICES
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Everything You Need,<br />All in One Place
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From legal setup to daily operations, we provide end-to-end support for overseas property owners.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-gray-900 to-gray-700 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-lg text-green-600 mt-0.5"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="inline-block px-10 py-4 bg-gray-900 text-white rounded-lg font-semibold text-lg hover:bg-gray-800 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>
  );
}